import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { C } from './tokens.js';
import { genUUID } from './utils.js';

const Ctx = createContext({ addToast: () => {} });
export function useToast() { return useContext(Ctx); }

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, kind = 'error') => {
    const id = genUUID();
    setToasts(ts => [...ts, { id, message, kind }]);
  }, []);

  const dismiss = useCallback((id) => {
    setToasts(ts => ts.filter(t => t.id !== id));
  }, []);

  return (
    <Ctx.Provider value={{ addToast }}>
      {children}
      {toasts.length > 0 && (
        <div style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 500,
          display: 'flex', flexDirection: 'column', gap: 8, pointerEvents: 'none',
        }}>
          {toasts.map(t => <Toast key={t.id} toast={t} onDismiss={() => dismiss(t.id)} />)}
        </div>
      )}
    </Ctx.Provider>
  );
}

function Toast({ toast, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 5000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  const isError = toast.kind === 'error';
  const isWarn  = toast.kind === 'warning';
  const bg      = isError ? '#FFF5F6' : isWarn ? '#FFFBEC' : '#F2FAEE';
  const border  = isError ? '#FFB3B3' : isWarn ? '#FFD88A' : '#C5E89A';
  const icon    = isError ? 'error_outline' : isWarn ? 'warning_amber' : 'check_circle_outline';
  const color   = isError ? C.rust : isWarn ? C.brass : C.patina;

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 14px',
      borderRadius: 6, background: bg, border: `1px solid ${border}`,
      boxShadow: '0 4px 16px rgba(0,0,0,0.14)', maxWidth: 400, minWidth: 260,
      pointerEvents: 'auto',
    }}>
      <span className="material-icons" style={{ fontSize: 18, color, flex: 'none', marginTop: 1 }}>{icon}</span>
      <span style={{ fontSize: 13, color: C.fg, flex: 1, lineHeight: 1.5 }}>{toast.message}</span>
      <button type="button" onClick={onDismiss}
        style={{ border: 'none', background: 'none', cursor: 'pointer', padding: 2, color: C.iron, flex: 'none', lineHeight: 1 }}>
        <span className="material-icons" style={{ fontSize: 16 }}>close</span>
      </button>
    </div>
  );
}
